import { inject, provide } from 'vue';
import type { InjectionKey } from 'vue';

type Injection<InjectionValue> = {
  provide: (value: InjectionValue) => void;
  inject: () => InjectionValue;
};

export function createInjection<InjectionValue>(name: string): Injection<InjectionValue> {
  // Symbol は Vue の InjectionKey ブランド型に変換が必要なため as を使用する
  const key = Symbol(name) as InjectionKey<InjectionValue>;
  return {
    provide: (value: InjectionValue) => provide(key, value),
    inject: (): InjectionValue => {
      const value = inject(key);
      if (value === undefined) {
        throw new Error(`"${key.toString()}" was not provided. Ensure "provide" is used before "inject".`);
      }
      return value;
    },
  };
}
